import Iconify from "@/src/components/iconify/Iconify";
import IconCode from "@/src/lib/iconCode";
import { NEXT_IMAGE_CDN } from "@/src/lib/util/config";

import Link from "next/link";

import NextLink from "next/link";

const PressReleaseList = ({ pressReleaseData }) => {
    // Format the date into day, month, year
    const releaseDate = new Date(pressReleaseData?.releaseDate);
    const day = releaseDate.getDate();
    const month = releaseDate.toLocaleString("default", { month: "short" }); // Get abbreviated month name
    const year = releaseDate.getFullYear();

    return (
        <div className="flex flex-row bg-white mb-6 relative shadow-md outline-0 outline-red-400 cursor-pointer outline-dashed hover:outline-1">
            <div className="size-36 bg-[#dc2625] text-white flex flex-col items-center justify-center max-w-32 w-full">
                <div className="font-bold text-white text-3xl">{day}</div>
                <div className="uppercase text-white text-sm">{month}</div>
                <div className="text-white text-sm">{year}</div>
            </div>

            <div className="p-4">
                <h2 className="text-black font-semibold md:text-xl text-lg">
                    {pressReleaseData?.releaseTitle}
                </h2>

                <p className="text-gray-600 text-sm">
                    {pressReleaseData?.releaseDescription}
                </p>

                <div className="mt-2 flex">
                    <Link
                        href={`${NEXT_IMAGE_CDN}/${pressReleaseData?.pdfUrl}`}
                        target="_blank"
                        className="inline-flex items-center gap-2 text-primary uppercase cursor-pointer px-3 py-1.5 rounded-sm font-medium text-sm hover:bg-primary/10 transition-all duration-300 border border-solid border-primary max-w-max"
                    >
                        <Iconify icon={IconCode.download} className="mr-2" />{" "}
                        Download
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default PressReleaseList;
